import {useLocation ,useNavigate } from 'react-router-dom'
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import {UserContextProvider} from './store/contexts/UserContextProvider';
import { AuthContextProvider } from './store/contexts/AuthContextProvider';
import { use, useEffect,useState} from 'react';
import TokenExpirationHandler from './components/tokenexpiration/TokenExpirationHandler';
import AppRoutes from './routes/AppRoutes';
import { GOOGLE_API_KEY } from './shared/constants/globalConstants';
import { MetadataContextProvider } from './store/contexts/MetadataContextProvider';
import { DeviceDetailsContext } from './store/contexts/UserDeviceContextProvider';
import { useMsal } from "@azure/msal-react"
import {authType, OTP_LOGIN, RHYBUS_ACCESS_TOKEN, RHYBUS_REFRESH_TOKEN } from './Configuration';
import OtpLogin from './components/otplogin/otplogin';
import LoginPage from './login';
import KeycloakGate from './store/contexts/KeycloakAuthContext';


const App= () => {
  const deviceContext = use(DeviceDetailsContext)
  const {accounts, inProgress } = useMsal();
  const [authMode, setAuthMode] = useState<AuthMode>("none");
  const [loading, setLoading] = useState(true);
   const location = useLocation();
   const navigate = useNavigate();
   
    type AuthMode = "msal" | "otp" | "keycloak" | "none";

    const clearTokens = () => {
      localStorage.removeItem(RHYBUS_ACCESS_TOKEN);
      localStorage.removeItem(RHYBUS_REFRESH_TOKEN);
      localStorage.removeItem(OTP_LOGIN);
    };


    useEffect(() => {
      const onLogout = () => {navigate("/otplogin",{state:{PrevPath: location.pathname}});};
      window.addEventListener("app-logout", onLogout);
      return () => window.removeEventListener("app-logout", onLogout);
    }, []);


    useEffect(() => {
      const currentPath = location.pathname.replace(/^\/+/, "").toLowerCase();
      const type = authType.toLowerCase();
      const isOtpToken = localStorage.getItem(OTP_LOGIN);
      const isRhyBusToken = localStorage.getItem(RHYBUS_ACCESS_TOKEN);

      let mode: AuthMode = "none";

      if (currentPath === "signout") {
        // 🔹 Forced logout
        clearTokens();
        navigate("/", { replace: true });

        // If MSAL is in use, mark mode = msal to trigger logoutRedirect
        if (type === "msal") {
          mode = "msal";
        }
      } 
      else if (type === "msal") {
        // 🔹 MSAL login mode
        mode = accounts.length > 0 ? "msal" : "msal";
      }
      else if (type === "keycloak") {
        // 🔹 Local-dev Keycloak login mode — KeycloakGate below handles its own auth check/redirect
        mode = "keycloak";
      }
      else if (type === "otp" && isOtpToken === "true" && isRhyBusToken) {
        // 🔹 OTP login mode
        mode = "otp";
      }

      setAuthMode(mode);

      if (inProgress === "none") {
        setLoading(false);
      }
    }, [accounts, inProgress, location.pathname, authType]);


  
   useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  if (loading || !deviceContext.isDeviceLoaded) {
    return <div></div>; 
  }  

  return (
    <>
      {deviceContext.isDeviceLoaded && (
        <>
          {deviceContext.isMobile && !deviceContext.isWeb  && authMode === "msal"? (
            <>
            <UserContextProvider>
                <MetadataContextProvider>
                  <AppRoutes authMode={authMode} onLogout={() => setAuthMode("none")} />
]                </MetadataContextProvider>
            </UserContextProvider>
            </>
          ) : (
            <>            

              {authMode === "msal" ? (
                <>
                 <TokenExpirationHandler />
                  <AuthenticatedTemplate>
                    <AuthContextProvider>
                      <UserContextProvider>
                          <MetadataContextProvider>
                            <AppRoutes authMode={authMode} onLogout={() => setAuthMode("none")}  />
                          </MetadataContextProvider>
                      </UserContextProvider>
                    </AuthContextProvider>
                  </AuthenticatedTemplate>
                  <UnauthenticatedTemplate>
                     <LoginPage 
                    />                   
                  </UnauthenticatedTemplate>
                </>
              ) : authMode === "otp" ? (
                <>
                <TokenExpirationHandler />
                <UserContextProvider>

                    <MetadataContextProvider>
                      <AppRoutes authMode={authMode} onLogout={() => setAuthMode("none")} />
                    </MetadataContextProvider>
                </UserContextProvider>
                </>
              ) : authMode === "keycloak" ? (
                <>
                <TokenExpirationHandler />
                <KeycloakGate>
                  <AuthContextProvider>
                    <UserContextProvider>
                      <MetadataContextProvider>
                        <AppRoutes authMode={authMode} onLogout={() => setAuthMode("none")} />
                      </MetadataContextProvider>
                    </UserContextProvider>
                  </AuthContextProvider>
                </KeycloakGate>
                </>
              ) : (
                <OtpLogin isAuthenticated={false}
                onLoginSuccess={async () => { setAuthMode("otp"); }}
                />
              )}
            
            </>
          )}
        </>
      )}
    </>
  );
};

export default App;
